export default function OfficerCard({ officer }) {
  const initials = officer.name && officer.name !== "TBD"
    ? officer.name.split(" ").map(w => w[0]).slice(0, 2).join("")
    : "?";
  return (
    <div className="officer-card">
      <div className="officer-photo-wrap">
        {officer.photo
          ? <img className="officer-photo" src={officer.photo} alt={officer.name}/>
          : <div className="officer-initials">{initials}</div>
        }
      </div>
      <div className="officer-name">{officer.name}</div>
      <div className="officer-pos">{officer.position}</div>
      {officer.clan && officer.clan !== "—" &&
        <div className="officer-clan">{officer.clan} Clan</div>
      }
    </div>
  );
}
